import axios from 'axios';
import {API} from "@/services/url";

export default {
	getSalesChannelList : function (success, error) {
		axios.get(API.salesChannel.all)
			.then(r => success(r.data))
			.catch(e => error(e.response.data.message));
	},
}